import Program from './Program';
import Texture from './Texture';
import vertexShader   from './shaders/default-vs.glsl';
import fragmentShader from './shaders/mesh-fs.glsl';


let defaultTexture;

class Material extends Program {

  constructor( gl, options  ){

    defaultTexture = defaultTexture || new Texture(gl)

    options = Object.assign({}, {
      vertexShader:   vertexShader,
      fragmentShader: fragmentShader,
      map: null,
    }, options);

    options.uniforms = Object.assign({}, {
      uColor: [0,1,0],
      uAlpha: 1,
      useMap: 0,
      tMap: defaultTexture,
    }, options.uniforms);

    options.defines = Object.assign({}, {
      USE_MAP: false
    }, options.defines);

    super(gl, options);
  
    if (!gl) {
      return;
    }


    Object.defineProperty(this, 'map', {
      set: (value) => {
        if (value) {
          if (this.uniforms.tMap) {
            this.uniforms.tMap.value = value;
            this.uniforms.useMap.value = 1;
          }
        }
        else {
          if (this.uniforms.useMap) {
            this.uniforms.useMap.value = 0;
          }
        }
      }
    });
      
    this.map = options.map;

  }



}

export default Material;